import { render, staticRenderFns } from "./add-product-modal.vue?vue&type=template&id=6b5c6a42&"
import script from "./add-product-modal.vue?vue&type=script&lang=tsx&"
export * from "./add-product-modal.vue?vue&type=script&lang=tsx&"
import style0 from "./add-product-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports